import React from 'react';
import PropTypes from 'prop-types';
import LinkedReferenceDescription from "./components/LinkedReferenceDescription";
import { Text } from "@adsk/bim360-matrix-react-components";
import T from "i18n-react";

const ChangesetDescription = ({ i18nKey, i18nParams }) => {
  if (!i18nKey) {
    return null;
  }
  if (i18nParams.linkNew && !i18nParams.linkOld) {
    return <LinkedReferenceDescription link={i18nParams.linkNew} />;
  }
  return <div><Text hasHTML>{T.translate(i18nKey, i18nParams)}</Text></div>;
};

ChangesetDescription.displayName = "ChangesetDescription";

ChangesetDescription.propTypes = {
  i18nKey: PropTypes.string,
  i18nParams: PropTypes.shape({
    linkNew: PropTypes.object,
    linkOld: PropTypes.object,
  }),
};
export default ChangesetDescription;
